export default defineAppConfig({
  navigation: {
    items: [
      {
        label: 'Home',
        to: '/common',
      },
    ],
  },
});
